// extracted by mini-css-extract-plugin
module.exports = {"header_bms":"DocumentScansPanel_header_bms__1M6c9","bms_header":"DocumentScansPanel_bms_header__1UJNZ","panel_area":"DocumentScansPanel_panel_area__gIGU7"};